module.exports = __webpack_public_path__ + "img/main-logo.eee93061.svg";